import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
  NbToastrService,
} from "@nebular/theme";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { filter, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { Catalog, Product } from "../../models/product.model";
import * as _ from "lodash";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DOUBLE_PATTERN } from "../../@auth/components/constants";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogProductComponent } from "../dialog-product/dialog-product.component";
import { CatalogService } from "../../services/catalog.service";
import { environment } from "../../../environments/environment";

@Component({
  selector: "ngx-view-list-products",
  styleUrls: ["./view-list-products.component.scss"],
  templateUrl: "./view-list-products.component.html",
})
export class ViewListProductsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() mode?: string = "receipt"; //receipt/purchase/trade
  @Output() onSelectedProduct: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  diaForm: FormGroup;

  @ViewChild("title") title: ElementRef;
  strSearch: string = "";
  uid = "anonymous";
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];
  isProduct = false;
  categories?: Catalog[];
  filterCatalog = false;
  selectedCatalog = "";
  page: number = 1;
  display?: Product[] = [];
  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  constructor(
    private userService: UserService,
    private productService: ProductService,
    private router: Router,
    private fb: FormBuilder,
    private dialogService: NbDialogService,
    private catalogService: CatalogService,
    private toastrService: NbToastrService,
    private themeService: NbThemeService,
    private nbMenuService: NbMenuService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.shopId = user.shopId;

          if (user.moderator || user.product) {
            this.isProduct = true;
          }

          this.display = _.clone(this.productService.products);
          this.getCatalogs();
        } else {
          this.uid = "anonymous";
        }
      });

    const titleValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const priceValidators = [Validators.pattern(DOUBLE_PATTERN)];

    this.diaForm = this.fb.group({
      title: ["", titleValidators],
      price: ["", priceValidators],
      costPrice: ["", priceValidators],
      quantity: ["", priceValidators],
      unit: [],
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getCatalogs(): void {
    this.loading = true;

    this.catalogService
      .getCatalogsByMode(this.shopId, "categories")
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (data) => {
          console.log("getCatalogs/categories:", data);
          this.categories = data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  selectCatalog(item: Catalog) {
    if (item) {
      this.filterCatalog = true;
      this.strSearch = item.title;
      this.selectedCatalog = item.id;
    } else {
      this.filterCatalog = false;
      this.strSearch = "";
      this.selectedCatalog = "";
    }
  }

  create() {
    this.strSearch = this.strSearch.trim();
    if (this.strSearch != "") {
      console.log(this.diaForm.value);

      let prod = new Product();
      prod.expDate = new Date();
      prod.shopId = this.shopId;
      prod.title = this.diaForm.value.title;
      prod.unitName = this.diaForm.value.unit ? this.diaForm.value.unit : "Cái";
      prod.price =
        this.mode === "receipt" || this.mode === "trade"
          ? parseFloat(this.diaForm.value.price.toString())
          : 0;
      prod.costPrice =
        this.mode === "purchase"
          ? parseFloat(this.diaForm.value.costPrice.toString())
          : 0;

      this.loading = true;
      this.submitted = true;

      this.productService
        .create(prod)
        .then((data) => {
          prod.id = data.id;
          prod.quantity =
            this.mode === "receipt" || this.mode === "trade"
              ? parseFloat(this.diaForm.value.quantity.toString())
              : 0;

          this.onSelectedProduct.emit(prod);

          this.diaForm.patchValue({
            title: "",
            price: "",
            costPrice: "",
            unit: "",
            quantity: "",
          });

          this.strSearch = "";
          this.title.nativeElement.focus();
          this.display = [...this.productService.products];

          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.productService
            .delete(this.shopId, item.id)
            .then((result) => {
              this.display = [...this.productService.products];
              this.loading = false;
              this.submitted = false;

              //sync data to offline DB
              item.isDeleted = true;
              this.productService.sync(item);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  eTitle = "";
  eUnit = "";
  ePrice = 0;
  eCostPrice = 0;
  isEditing = false;
  onEdit(item: Product): void {
    item.editing = true;
    this.eTitle = item.title;
    this.eUnit = item.unitName;
    this.ePrice = item.price;
    this.eCostPrice = item.costPrice;
    this.isEditing = true;
  }
  cancelEdit(item: Product) {
    item.editing = false;
    this.isEditing = false;
  }
  confirmEdit(item: Product) {
    item.loading = true;
    item.title = this.eTitle;
    item.unitName = this.eUnit ? this.eUnit : "";
    item.price = this.ePrice ? parseFloat(this.ePrice.toString()) : 0;
    item.costPrice = this.eCostPrice
      ? parseFloat(this.eCostPrice.toString())
      : 0;

    this.productService
      .updatePrice(
        this.shopId,
        item.id,
        item.title,
        item.unitName,
        item.price,
        item.costPrice
      )
      .then((data) => {
        this.eTitle = "";
        this.eUnit = "";
        this.ePrice = 0;
        this.eCostPrice = 0;

        item.editing = false;
        item.loading = false;
        this.isEditing = false;

        //sync data to offline DB
        this.productService.sync(item);
      })
      .catch((err) => {
        item.loading = false;
      });
  }

  selected(item: Product): void {
    this.onSelectedProduct.emit(item);

    if (this.filterCatalog) {
      this.diaForm.patchValue({
        price: "",
        costPrice: "",
      });
    } else {
      this.diaForm.patchValue({
        title: "",
        price: "",
        costPrice: "",
        unit: "",
        quantity: "",
      });
      this.display = [...this.productService.products];
    }

    this.title.nativeElement.focus();
  }

  onSearch(): void {
    this.page = 1;
    const strFilter = this.strSearch.toLowerCase();

    this.loading = true;
    if (!strFilter || strFilter === "") {
      this.display = [...this.productService.products];
      this.loading = false;
    } else {
      this.display = _.filter(this.display, function (item) {
        const title = item.title ? item.title.toLowerCase() : "";
        const description = item.description
          ? item.description.toLowerCase()
          : "";
        const barcode = item.barcode ? item.barcode.toLowerCase() : "";
        return (
          (title && title.includes(strFilter)) ||
          (description && description.includes(strFilter)) ||
          (barcode && barcode.includes(strFilter))
        );
      });
    }
    this.loading = false;
  }
}
